import { Component } from '@angular/core';

import { LoaderService } from '../services/loader/loader.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  constructor(public _loaderService: LoaderService,
    protected titleService: Title
  ) { 
    this.titleService.setTitle("Portal");
  }
}
